import {
    get,
    post,
    put,
    del

} from '../configApi'
export async function loadListNotification(params) {
    return await get(`/notification/listschedule`, params)
}
export async function loadListBinNotification(params) {
    return await get(`/notification/listtrashschedule`, params)
}
//   export async function insertCategory(body) {
//     return await post(`/category/manage/insert`,body)
//   }
//   export async function updateCategory(body) {
//     return await put(`/category/manage/update`,body)
//   }
export async function updateActive(body) {
    return await put(`/notification/manage/active`, body)
}
export async function deleteNotification(body) {
    return await del(`/notification/manage/delete`, body)
}
